import { Container } from 'react-bootstrap';
import './style.scss';

function Footer() {
  return (
    <div className="footer-section">
      <Container fluid className="d-flex justify-content-between">
        <span>{process.env.REACT_APP_APP_NAME}</span>
        <span className="footer-log-version">{process.env.REACT_APP_LOG_VERSION}</span>
      </Container>
    </div>
  );
}

export default Footer;
